module.exports = __webpack_public_path__ + "img/cp-2.14234fba.png";